export default [
  {
    name: 'login',//登录
    path: '/login',
    meta: {
      title: '登录',
      goHome: true,
    },
    component: () => import("@/pages/login/login.vue"),
  },
  {
    name: 'register',//注册
    path: '/register',
    meta: {
      title: '注册',
      goHome: true,
    },
    component: () => import("@/pages/login/register.vue"),
  },
  {
    name: 'applyRegister',//申请注册
    path: '/applyRegister',
    meta: {
      title: '申请注册',
      goHome: true,
    },
    component: () => import("@/pages/login/applyRegister.vue"),
  },
  {
    name: 'applySuccess',//审核结果审核中
    path: '/applySuccess',
    meta: {
      title: '审核结果',
      goHome: true,
    },
    component: () => import("@/pages/login/applySuccess.vue"),
  },
  {
    name: 'applyInfo',//审核结果
    path: '/applyInfo',
    meta: {
      title: '审核结果',
      goHome: true,
  },
    component: () => import("@/pages/login/applyInfo.vue"),
  },
  {
    name: 'appCard',//上传照片
    path: '/appCard',
    meta: {
      title: '上传照片',
      goHome: true,
  },
    component: () => import("@/pages/login/appCard.vue"),
  },
  {
    name: 'appFace',//拍照人脸识别
    path: '/appFace',
    meta: {
      title: '人脸识别',
      goHome: true,
  },
    component: () => import("@/pages/login/appFace.vue"),
  },
  {
    name: 'appLiveFace',//活体人脸识别
    path: '/appLiveFace',
    meta: {
      title: '人脸识别',
      goHome: true,
  },
    component: () => import("@/pages/login/appLiveFace.vue"),
  },
  {
    name: 'appSuccess',//人证结果
    path: '/appSuccess',
    meta: {
      title: '人证结果',
      goHome: true,
    },
    component: () => import("@/pages/login/appSuccess.vue"),
  },
  {
    name: 'appFail',//人证结果
    path: '/appFail',
    meta: {
      title: '人证结果',
      goHome: true,
    },
    component: () => import("@/pages/login/appFail.vue"),
  },
  {
    name: 'bindPhone',//绑定手机
    path: '/bindPhone',
    meta: {
      title: '绑定手机',
      goHome: true,
    },
    component: () => import("@/pages/login/bindPhone.vue"),
  },
]